// Detect whether we're running inside a Capacitor (native) shell.
export function isNative(): boolean {
  if (typeof window === "undefined") return false;
  const cap = (window as any).Capacitor;
  if (!cap) return false;
  if (typeof cap.isNativePlatform === "function") return Boolean(cap.isNativePlatform());
  return Boolean(cap.platform && cap.platform !== "web");
}
